import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetShopProductByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type GetShopProductByIdQuery = { __typename?: 'query_root', shop_products_by_pk?: { __typename?: 'shop_products', id: any, product_id: any, property_id: any, created_at: any, product?: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, organization_id?: any | null, workspace_id?: any | null, created_at?: any | null, retail_price?: any | null, extended_price?: any | null, photo_link?: string | null, partition_id?: string | null, parent_product_id?: any | null, product_category: { __typename?: 'product_categories', name: string, label: string }, parent_product?: { __typename?: 'products', id: any, name: string, make: string, model: string, description: string, partition_id?: string | null } | null, product_attachments: Array<{ __typename?: 'product_attachments', id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed: boolean, type?: string | null, description?: string | null, name?: string | null }> } | null, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, partition_id?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null } | null } | null };


export const GetShopProductByIdDocument = gql`
    query getShopProductById($id: uuid!) {
  shop_products_by_pk(id: $id) {
    id
    product_id
    property_id
    created_at
    product {
      id
      name
      description
      sku
      product_category {
        name
        label
      }
      make
      model
      organization_id
      workspace_id
      created_at
      retail_price
      extended_price
      photo_link
      partition_id
      parent_product_id
      parent_product {
        id
        name
        make
        model
        description
        partition_id
      }
      product_attachments(order_by: {created_at: asc}) {
        id
        photo_link
        document_link
        video_link
        audio_link
        site_link
        transcription
        transcribed
        type
        description
        name
      }
    }
    property {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      partition_id
    }
  }
}
    `;

/**
 * __useGetShopProductByIdQuery__
 *
 * To run a query within a React component, call `useGetShopProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetShopProductByIdQuery(baseOptions: Apollo.QueryHookOptions<GetShopProductByIdQuery, GetShopProductByIdQueryVariables> & ({ variables: GetShopProductByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopProductByIdQuery, GetShopProductByIdQueryVariables>(GetShopProductByIdDocument, options);
      }
export function useGetShopProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopProductByIdQuery, GetShopProductByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopProductByIdQuery, GetShopProductByIdQueryVariables>(GetShopProductByIdDocument, options);
        }
export function useGetShopProductByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShopProductByIdQuery, GetShopProductByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShopProductByIdQuery, GetShopProductByIdQueryVariables>(GetShopProductByIdDocument, options);
        }
export type GetShopProductByIdQueryHookResult = ReturnType<typeof useGetShopProductByIdQuery>;
export type GetShopProductByIdLazyQueryHookResult = ReturnType<typeof useGetShopProductByIdLazyQuery>;
export type GetShopProductByIdSuspenseQueryHookResult = ReturnType<typeof useGetShopProductByIdSuspenseQuery>;
export type GetShopProductByIdQueryResult = Apollo.QueryResult<GetShopProductByIdQuery, GetShopProductByIdQueryVariables>;